import React, { useCallback } from 'react';
import { useModal } from '@ebay/nice-modal-react';

import { Receipt } from '@ocx/feat-pay-at-pump';
import { ModalFullScreenDrawer, ModalFullScreenHeader, ModalFullScreenContent } from '@ocx/ui-modals';

import { IReceiptOption } from '../../../modules/transaction/types';

export type TransactionReceiptPopupProps = {
  onClose?(): void;
  receipt: {
    addressLine: string;
    carWashCode?: string | null;
    receiptLines: string[];
    options: IReceiptOption[];
    total: number;
  };
};

export const TransactionReceiptPopupController = (props: TransactionReceiptPopupProps) => {
  const { visible, hide, remove } = useModal();

  const { receipt, onClose } = props;

  const handleClose = useCallback(() => {
    onClose?.();
    hide();
  }, [onClose, hide]);

  return (
    <ModalFullScreenDrawer open={visible} onClose={handleClose} onExited={remove}>
      <ModalFullScreenHeader onBackClick={hide} />
      <ModalFullScreenContent>
        <Receipt {...receipt} onCloseButtonClick={handleClose} />
      </ModalFullScreenContent>
    </ModalFullScreenDrawer>
  );
};
